import AddAppointmentContentStep2Vip from "./Vip";
import AddAppointmentContentStep2Normal from "./Normal";

const AddAppointmentContentStep2 = ({ 
  method, 
  availabilityData, 
  onBack, 
  onContinue, 
  axiosAdmin,
  onStepDataChange,
  serviceId,
  type,
  internalSelectedDateNormal,
  setInternalSelectedDateNormal,
  internalSelectedDateVip,
  setInternalSelectedDateVip,
  nowDate,

  selectedTimeNormal,
  setSelectedTimeNormal,
  selectedStaffNormal,
  setSelectedStaffNormal,

  selectedTimeVip,
  setSelectedTimeVip
}) => {
  if (method === "vip") {
    return (
      <AddAppointmentContentStep2Vip
        availabilityData={availabilityData}
        onBack={onBack}
        onContinue={onContinue}
        axiosAdmin={axiosAdmin}

        internalSelectedDate={internalSelectedDateVip}
        setInternalSelectedDate={setInternalSelectedDateVip}

        selectedTime={selectedTimeVip}
        setSelectedTime={setSelectedTimeVip}
      />
    );
  }
  return (
    <AddAppointmentContentStep2Normal
      availabilityData={availabilityData}
      axiosAdmin={axiosAdmin}
      serviceId={serviceId}
      type={type}
      onStepDataChange={onStepDataChange}

      internalSelectedDate={internalSelectedDateNormal}
      setInternalSelectedDate={setInternalSelectedDateNormal}
      nowDate={nowDate}

      selectedTime={selectedTimeNormal}
      setSelectedTime={setSelectedTimeNormal}
      selectedStaff={selectedStaffNormal}
      setSelectedStaff={setSelectedStaffNormal}
    />
  );
};

export default AddAppointmentContentStep2;
